import { Box, Typography, useMediaQuery, Menu, MenuItem } from '@mui/material';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { DeleteRecord } from '../../deleteRecord';
import { useTheme } from '@mui/material/styles';
import { useListBackNavigation } from '../../../hooks/listNavigation';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Iconify from '../../Iconify';
import axios from 'axios';
import '../../../css/invoices/invoiceDetailsHeader.css';

const InvoiceDetailsHeader = () => {

    const { t } = useTranslation();
    const { goBack, goToList } = useListBackNavigation('/dashboard/factures');
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const invoiceDetailsData = useSelector((state) => state.InvoiceDetailsData);

    const hasInvoiceDeletePermission = useHasPermission('facture_delete');

    const [errMsg, setErrMsg] = useState('');
    const [deleteInvoice, setDeleteInvoice] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const openActionMenu = Boolean(anchorEl);

    const handleDeleteInvoice = async () => {
        try {
            const response = await axios.delete(`invoice/${invoiceDetailsData.id}`);
            if (response.status === 200 || response.status === 201) {
                setDeleteInvoice(false);
                goToList();
                setErrMsg('');
            }
        } catch (error) {
            setErrMsg(error.message || "Erreur lors de la suppression de l'invoice");
            console.error('Error updating invoice status:', error);
            CustomErrorLogger(error, "Delete Invoice");
        }
    }

    const handleOpenActionMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseActionMenu = () => {
        setAnchorEl(null);
    };

    const handleGoBack = goBack;

    return (
        <Box className="InvoiceDetailsHeader_mainBox">
            <Box className="InvoiceDetailsHeader_firstPart">
                <Iconify className='InvoiceDetailsHeader_back_icon' icon={"material-symbols:arrow-back"} onClick={handleGoBack} />
                <Typography className="InvoiceDetailsHeader_title">{invoiceDetailsData?.title} <Iconify className='InvoiceDetailsHeader_title' icon={"tabler:number"} /> {invoiceDetailsData?.invoice_number}</Typography>
            </Box>
            <Box className="InvoiceDetailsHeader_secondPart">
                {isDesktop && hasInvoiceDeletePermission &&
                    <Box className="InvoiceDetailsHeader_action_box" onClick={() => setDeleteInvoice(true)}>
                        <Iconify className='InvoiceDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                        <Typography className="InvoiceDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                    </Box>
                }
                {!isDesktop && <Iconify
                    className='InvoiceDetailsHeader_dots_icon'
                    icon={"vaadin:ellipsis-dots-v"}
                    id="userPageActionMenuIcom"
                    aria-controls={openActionMenu ? 'long-menu' : undefined}
                    aria-expanded={openActionMenu ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleOpenActionMenu}
                />}
                <Menu
                    id="usersePageActionMenu"
                    MenuListProps="usersPageActionMenuIcom"
                    open={openActionMenu}
                    anchorEl={anchorEl}
                    onClose={handleCloseActionMenu}
                    onClick={handleCloseActionMenu}
                    slotProps={{ paper: { style: { width: '30ch', backgroundColor: '#fffff' } } }}
                >
                    {!isDesktop && hasInvoiceDeletePermission &&
                        <MenuItem className='InvoiceDetailsHeader_menuItem' onClick={() => setDeleteInvoice(true)}>
                            <Iconify className='InvoiceDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                            <Typography className="InvoiceDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                        </MenuItem>
                    }
                </Menu>
            </Box>

            {deleteInvoice &&
                <DeleteRecord
                    errMsg={errMsg}
                    setErrMsg={setErrMsg}
                    openDelete={deleteInvoice}
                    setOpenDelete={setDeleteInvoice}
                    handleDelete={handleDeleteInvoice}
                    title="Êtes-vous sûr du vouloir supprimer l'invoice ?"
                />
            }
        </Box>
    );
}

export default InvoiceDetailsHeader;